import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { StorageHelper } from '../utils/storageHelper';

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  const isLoggedIn = !!context.token || !!StorageHelper.get('token');  
  return {
    ...context,
    isLoggedIn
  };
};